import { union } from "lodash";
import AppContext from "PFApp/app_context";
import ColumnsHeaders from "PFApp/components/table/columns_headers";
import { Panel } from "PFApp/components/table/panel";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { getTitleWithCounter, isDraft } from "../../helpers";
import BulkActionsHeader from "../bulk_actions_header";
import GroupByView from "../group_by_view";
import { UnseenOwnership } from "../unseen_ownership/unseen_ownership";
import EngagementsHeader from "./engagements_header";
import EngagementsListView from "./engagements_list_view";
import EngagementsRowsConnected from "./engagements_rows_connected";
import css from "./engagements_table.module.scss";

const EngagementsTable = () => {
  const {
    store: {
      pages: {
        workflowPage: {
          engagements: {
            columns,
            data: { meta, entries, loading },
            onOrderChange,
            groupBy,
            selectMode,
            setSelectMode,
            selectedIds,
            setSelectedIds,
            unseen,
            pinnedIds
          }
        }
      }
    }
  } = useContext(AppContext);
  const { t } = useTranslation("workflow", { keyPrefix: "parts.engagements" });

  const anyUnseen = unseen.engagements.length > 0;

  const isDraftTab = isDraft(meta);
  const title = anyUnseen ? t("translation:all") : t("engagements");
  const titleWithCounter = getTitleWithCounter(title, meta?.counters.filtered_activities_count);

  return (
    <>
      {anyUnseen && (
        <UnseenOwnership activityType="engagement">
          <ColumnsHeaders
            columns={columns}
            onOrderChange={onOrderChange}
            order={meta.order}
            className={css.headers}
          />
          <EngagementsRowsConnected items={unseen.engagements} isLoading={unseen.loading} />
        </UnseenOwnership>
      )}

      <Panel title={titleWithCounter}>
        <div className={css.root}>
          <EngagementsHeader />
          {selectMode && !isDraftTab && (
            <BulkActionsHeader
              total={meta.total}
              allowSelectAll={!groupBy}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              itemsIds={union(
                entries.map(({ id }) => id),
                pinnedIds
              )}
              setSelectMode={setSelectMode}
              activityType="engagement"
            />
          )}
          <div className={css.scrollWrapper}>
            <div className={css.list}>
              {(isDraftTab || !selectMode) && (
                <ColumnsHeaders
                  columns={columns}
                  onOrderChange={onOrderChange}
                  order={meta.order}
                  className={css.headers}
                />
              )}
              {groupBy ? (
                <GroupByView groupByFilterKey={groupBy} meta={meta} type="engagements" isFetching={loading} />
              ) : (
                <EngagementsListView />
              )}
            </div>
          </div>
        </div>
      </Panel>
    </>
  );
};

export default EngagementsTable;
